import { io } from 'socket.io-client';

const ENDPOINT = process.env.REACT_APP_BACKEND_DOMAIN_URL;
const socket = io(ENDPOINT, {
  reconnection: true, // Enable auto-reconnection
  reconnectionAttempts: 10, // Number of reconnection attempts before giving up
  reconnectionDelay: 1000, // Time between reconnections (1 second)
  reconnectionDelayMax: 5000, // Maximum time between reconnections (5 seconds)
  timeout: 20000,
  transports: ['websocket'],
});
export default socket;
